export default __webpack_public_path__ + "static/media/kinghost-horizontal.55b1ee96.svg";